var _circle, _circle2, _path, _circle3, _path2, _rect, _rect2, _path3, _rect3, _rect4, _rect5, _path4, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSalesChannelsEmptyState = function SvgSalesChannelsEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 96,
    fill: "none",
    className: "svgr-icon"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2,
    cy: 16.2,
    r: 9.72,
    fill: "#FFC76C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.7,
    cy: 3.7,
    r: 3.7,
    fill: "#FFC76C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EB6552",
    d: "M111.2 84.3a4.663 4.663 0 0 0 6.45 1.48 4.707 4.707 0 0 0 1.48-6.48 4.663 4.663 0 0 0-6.45-1.48 4.707 4.707 0 0 0-1.48 6.48"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 80,
    r: 8,
    fill: "#EB6552"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1B",
    strokeDasharray: "3 3",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M40 50h42"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    x: 30,
    y: 38,
    fill: "#9ED8F0",
    rx: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    x: 25,
    y: 34,
    fill: "#FEE1BF",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    rx: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB6552",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    d: "M27 40c0-3 2-5 5-5h12c3 0 5 2 5 5v3H27z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 12,
    x: 33,
    y: 48,
    fill: "#1D1D1B",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    x: 71,
    y: 38,
    fill: "#9ED8F0",
    rx: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    x: 66,
    y: 34,
    fill: "#FEE1BF",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    rx: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9ED8F0",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    d: "M68 40c0-3 2-5 5-5h12c3 0 5 2 5 5v3H68z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 12,
    x: 74,
    y: 48,
    fill: "#1D1D1B",
    rx: 1
  })));
};
export default SvgSalesChannelsEmptyState;